import { FormUnit, type GetFormInput } from "@suse-o11y/signal/form";

import { isStringDirty } from "~/tools/is-string-dirty";
import { trim } from "~/tools/trim";

type FormState = FormUnit<string, null, undefined | string>;

type Input = GetFormInput<FormState>;

const INITIAL = "" satisfies Input;

function init(initial?: Input): FormState {
	return FormUnit(initial ?? INITIAL, {
		isInputDirty: isStringDirty,
		transform: (input) => trim(input) || undefined,
	});
}

const FormState = {
	initial: INITIAL,
	init,
} as const;

export { FormState };
